let bugSnagInternal = {
  notify: () => null,
  setContext: () => null,
  leaveBreadcrumb: () => null,
};

export const bugsnag = bugSnagInternal;
